import React from 'react';
import { useGlobalHoveredId, useGlobalSelectedId } from '../../data/StatusStore';
import { d2gRound } from '../utilities/Utilities';

interface RangeSwarmMetaProps {
  dataArray: DataItem[];
  indicator: any;
  data: any;
}

interface DataItem {
  id: string;
  value: number;
  x?: number;
  y?: number;
}

const RangeSwarmMeta: React.FC<RangeSwarmMetaProps> = ({ dataArray, indicator, data }) => {
  const hoveredId = useGlobalHoveredId();
  const selectedId = useGlobalSelectedId() as any;

  return (
    <>
      <div className="module-child-1-meta">
        <div className='module-meta-stat-label'>
          <div className="module-meta-stat">
            {selectedId && indicator && indicator.variable ? d2gRound(data.dataJSON[selectedId][indicator.variable], { DESCRIPTOR: data.meta["DESCRIPTOR"][indicator.variable] }) : "NA"}
          </div>
        </div>
      </div>
      <div
        style={{
          marginRight: "15px",
          overflowX: "hidden",
          overflowY: "auto",
          height: "calc(100% - 44px)",
        }}
      >
        {`${data.meta["NOTES"][indicator.variable]}`}
        <br /><div style={{ color: '#9E9C9C', paddingTop: '5px' }}>Source: <a className="source-link" href={`${data.meta["SOURCE URL"][indicator.variable]}`} target='_blank'>{`${data.meta["SOURCE NAME"][indicator.variable]}`}</a></div>
      </div>
    </>
  );
};

export default RangeSwarmMeta;